'use strict';

/*global isEmpty */
/*objekt Container*/
function Container() {
    this.container = null;
    
    this.init();
}

Container.prototype = $.extend({}, {
    constructor: 'Container',
    
    //**************************************************************************    
    get: function get(id) {
        var _this = this;

        if (!_this.has(id)) {
            throw id + ' does not exists in container!';
        }

        return _this.container[id];
    },
    
    set: function set(id, value) {
        var _this = this;

        _this.container[id] = value;
        return _this;
    },

    remove: function remove(id) {
        var _this = this;

        if(!isEmpty(_this.container[id])) {
            delete _this.container[id];
        } 
        
        return _this;
    },

    has: function has(id) {
        var _this = this;

        return id in _this.container;
    },

    loadFromArray: function loadFromArray(array) {
        var _this = this;

        $.each(array, function (id, value) {
            _this.set(id, value);
        });
    },
    
    //**************************************************************************
    init: function init() {
        var _this = this;

        _this.container = {};
    }
});
